import * as date from 'Utils/date'
import { ADMIN_FEEDBACK_OPTIONS, EMPTY_RESPONSE_MESSAGE, EMPTY_RESPONSE_TOOLTIP, FALLBACK_TEXT } from 'Src/constants'
import { getVisitorFeedbackLabel } from './utils'
import { domPurifyAllTagsAndKeepContent } from 'Utils/dom-purify'
import { useSelector } from 'react-redux'
import { $getAccountDetails } from 'Selectors/account'
import InfoIcon from 'Images/information-line.svg'
import ReactToolTip from 'Components/ReactTooltip'
import styles from './TrainingListWithAI.module.scss'

const NoRender = () => null

const EmptyResponseMessage = () => {
  const accountData = useSelector($getAccountDetails)
  const message = EMPTY_RESPONSE_MESSAGE.replace('{companyName}', accountData?.company_name)
  return (
    <div className={styles.ResponseShownByBot}>
      <ReactToolTip
        asChild
        side='right'
        className={styles.ResponseShownByBotTooltipContent}
        content={<div>{EMPTY_RESPONSE_TOOLTIP}</div>}
      >
        <div className={styles.InfoIcon}>
          <InfoIcon width='15px' height='15px' />
        </div>
      </ReactToolTip>
      <div className={styles.CellContent}>{message}</div>
    </div>
  )
}

export const ResponseShownByBot = ({ cell }) => {
  const { content_used_for_generating_response } = cell.row.original.data
  const wasNotAbleToAnswer =
    content_used_for_generating_response === null || content_used_for_generating_response.has_answer === false

  if (wasNotAbleToAnswer) {
    return <EmptyResponseMessage />
  }

  const { value } = cell

  if (!value) {
    return <NoRender />
  }

  return domPurifyAllTagsAndKeepContent(value)
}

export const VisitorFeedback = ({ cell }) => {
  const { value } = cell

  return getVisitorFeedbackLabel(value)
}

export const AdminFeedback = ({ cell }) => {
  const { value } = cell
  const label = ADMIN_FEEDBACK_OPTIONS.find(({ value: optionValue }) => optionValue === value)?.label
  return label || FALLBACK_TEXT
}

export const CreatedOn = ({ cell }) => {
  const { value } = cell
  return value ? date.formatRelativeDate(value, 7) : FALLBACK_TEXT
}
